import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class MessageService {

  // Tempo padrão em milissegundos (5 segundos)
  private defaultTimeOut = 5000;

  constructor(private toastr: ToastrService) {}

  showSuccess(message: string, title = '', timeOut = this.defaultTimeOut): void {
    this.toastr.success(message, title, { timeOut });
  }

  showInformation(message: string, title = '', timeOut = this.defaultTimeOut): void {
    this.toastr.info(message, title, { timeOut });
  }

  showAlert(message: string, title = '', timeOut = this.defaultTimeOut): void {
    this.toastr.warning(message, title, { timeOut });
  }

  showError(message: string, title = '', timeOut = 7000): void {
    this.toastr.error(message, title, { timeOut });
  }

  showLoading(message: string, title = ''): void {
    this.toastr.clear();
    this.toastr.info(message, title, { timeOut: 0, disableTimeOut: true });
  }

  clearLoading(): void {
    this.toastr.clear();
  }
}
